import { memo } from 'react';
import cn from "classnames";
import { useTranslation } from "next-i18next";
import i from "@styles/icons.module.scss";
import s from "./SliderControls.module.scss";

const SliderControls = ({
  hideNumbers = true,
  buttonPrevRef,
  buttonNextRef,
  className,
  slidesCount,
  currentSlide,
  isEnd,
  isStart,
  isWait,
  interval,
  nextSlide,
  prevSlide,
}) => {
  const { t } = useTranslation();
  return (
    <div className={cn(s.controls, className)}>
      <div
        // ref={buttonPrevRef}
        onClick={prevSlide}
        className={cn(s.button, s.prev)}
        // disabled={currentSlide == 0}
        disabled={isStart}
      >
        <icon className={i.arrowLeft} />
        {t("prev")}
      </div>
      <div className={cn(s.timer, isWait && s.wait)}>
        <div
          className={s.progress}
          style={{ transition: `${interval}ms linear` }}
        />
      </div>
      {/* {hideNumbers ? (
        <div className={s.divider} />
      ) : (
        <div className={s.count}>
          {currentSlide + 1} / {slidesCount}
        </div>
      )} */}

      <div
        // ref={buttonNextRef}
        onClick={nextSlide}
        className={cn(s.button, s.next)}
        // disabled={currentSlide + 1 == slidesCount}
        disabled={isEnd}
      >
        {t("next")}
        <icon className={i.arrowRight} />
      </div>
    </div>
  );
};

export default memo(SliderControls);
